
            <div class="admin-variant-summary-col te-variant-para-style">
                <p>{{'List of variants available for use on Targeting Engine'|translate}}</p><br>

               <div *ngFor="let obj of variantDetails, let ind=index">
                    {{obj}}
   
    <img *ngIf= "!showArray[ind]"  src="assets/images/admin-plus.gif"  width="15" height="15" (click)="getVariantDetails(obj,ind);">
    <img *ngIf= "showArray[ind]"  src="assets/images/admin-minus.gif"  width="15" height="15" (click)="getVariantDetails(obj,ind);">
  
    <ng-container *ngIf= "showArray[ind]">
        <table>
        <thead >
        <tr class="admin-variant-summary-tab-header">{{'DIAGNOSTIC'|translate}}</tr>
        <tr>
        <td class="variant-sum-th1">{{'Procedure Id'|translate}}</td>
        <td class="variant-sum-th2">{{'Available'|translate}}</td>
        <td class="variant-sum-th3">{{'Mapped'|translate}}</td>
        <td class="variant-sum-th4">{{'Online'|translate}}</td>
        <td>{{'Offline'|translate}}</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let tab of tabData1[ind]">
         <td [ngClass]="tab.procedureid == false ? 'var-tab-col' : ''">{{tab.procedureId}}</td>
         <td [ngClass]="tab.available == false ? 'var-tab-col' : ''">{{tab.available}}</td>
         <td [ngClass]="tab.mapped == false ? 'var-tab-col' : ''">{{tab.mapped}}</td>
         <td [ngClass]="tab.onlineRule == false ? 'var-tab-col' : ''">{{tab.onlineRule}}</td>
         <td [ngClass]="tab.offlineRule== false ? 'var-tab-col' : ''">{{tab.offlineRule}}</td>
        </tr>
        
        </tbody>
        </table>
        <table>
        <thead >
        <tr class="admin-variant-summary-tab-header">{{'Repair'|translate}}</tr>
        <tr>
         <td class="variant-sum-th1">{{'Procedure Id'|translate}}</td>
        <td class="variant-sum-th2">{{'Available'|translate}}</td>
        <td class="variant-sum-th3">{{'Mapped'|translate}}</td>
        <td class="variant-sum-th4">{{'Online'|translate}}</td>
        <td>{{'Offline'|translate}}</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let tab of tabData[ind]">
         <td [ngClass]="tab.procedureid == false ? 'var-tab-col' : ''">{{tab.procedureId}}</td>
         <td [ngClass]="tab.available == false ? 'var-tab-col' : ''">{{tab.available}}</td>
         <td [ngClass]="tab.mapped == false ? 'var-tab-col' : ''">{{tab.mapped}}</td>
         <td [ngClass]="tab.onlineRule == false ? 'var-tab-col' : ''">{{tab.onlineRule}}</td>
         <td [ngClass]="tab.offlineRule== false ? 'var-tab-col' : ''">{{tab.offlineRule}}</td>
        </tr>
        
        </tbody>
        </table>
        <table>
        <thead >
        <tr class="admin-variant-summary-tab-header">{{'Post Repair'|translate}}</tr>
        <tr>
        <td class="variant-sum-th1">{{'Procedure Id'|translate}}</td>
        <td class="variant-sum-th2">{{'Available'|translate}}</td>
        <td class="variant-sum-th3">{{'Mapped'|translate}}</td>
        <td class="variant-sum-th4">{{'Online'|translate}}</td>
        <td>{{'Offline'|translate}}</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let tab of tabData2[ind]">
        <td [ngClass]="tab.procedureid == false ? 'var-tab-col' : ''">{{tab.procedureId}}</td>
        <td [ngClass]="tab.available == false ? 'var-tab-col' : ''">{{tab.available}}</td>
        <td [ngClass]="tab.mapped == false ? 'var-tab-col' : ''">{{tab.mapped}}</td>
        <td [ngClass]="tab.onlineRule == false ? 'var-tab-col' : ''">{{tab.onlineRule}}</td>
        <td [ngClass]="tab.offlineRule== false ? 'var-tab-col' : ''">{{tab.offlineRule}}</td>
        </tr>
        
        </tbody>
        </table>
        </ng-container>
     </div> 
              </div> 


         